export default __webpack_public_path__ + "static/media/faralya6.b46d9126.jpg";